import { Box } from "@mui/material";
import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TkButton from "../../components/atoms/TkButton";
import TkDatePicker from "../../components/atoms/TkDatePicker";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import { IAPI_APP016_Request, IAPI_REC011_Request } from "../../type/apiType";
import "./_style.scss";
import {
  httpAPI_APP016,
  httpAPI_REC011,
  httpAPI_REC013,
  httpAPI_REC030,
  httpAPI_COM009,
  httpAPI_COM005,
} from "./api/request";
import { GetBodyList, funStatusBodyList } from "./hooks/useHooks";
import {
  headList,
  headListHistory,
  listData,
  schema,
  listData2,
} from "./parts";
import {
  CommonOrCommonRetirementFlug,
  FormClassApply,
  FormKbn,
  InquiryCode,
} from "../../assets/data/Constants";
import { isStatusAfterApproval } from "../../utils/useTools";
import _ from "lodash";
import { TkRouteContext } from "../../context/tkRouteContext";
import { TkGetCode } from "../../utils/TkGetCode";

/**
 * SCRW160009 過納金一覧
 * @return SCRW160009 過納金一覧
 */
const SCRW160009 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessStete } =
    useContext(BusinessContext);
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const context = businessState.paymentManagement?.searchForOverPayment;
  // 入金日
  const [paymentDay, setPaymentDay] = useState("");
  const [dateError, setDateError] = useState(false);
  // 件数
  const [numData, setNumData] = useState<any>(0);
  // TkDataTableのbodyList
  const [bodyListData, setBodyListData] = useState<any>([]);
  // ダイアログ
  const [isOpen, setIsOpen] = useState(false);
  // tableList
  const [tableListData, setTableListData] = useState<any>([]);
  // 選択したリスト
  const [selectListData, setSelectListData] = useState([]);
  // 掛金の過納額の返戻について（通知文差込データ用）
  const [bodyListData2, setBodyListData2] = useState<any>([]);
  const [status, setStatus] = useState<any>("");
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>();
  const [statusBodyList, setStatusBodyList] = useState<any>([]);
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [isOpenWork, setIsOpenWork] = useState(false);
  const wantToSetInRouterList = useRef<any>([
    {
      title: "機構職員ホーム",
      href: "/SCRW110001",
    },
    {
      href: "/SCRW160009",
      title: "過納金一覧",
    },
  ]);
  const applyId = location.state?.applyId;
  const currentBusinessJob =
    businessState[
      businessState.common?.businessType
        ?.toLowerCase()
        .replace("-", "_") as keyof typeof businessState
    ];
  const timerId = useRef<NodeJS.Timeout | null>(null);
  const [stateSearchList, setStateSearchList] = useState<any>();
  const searchList = useRef(_.cloneDeep(listData));

  useEffect(() => {
    let resArr = searchList.current;
    if (applyId) {
      handInit();
    }
    if (context) {
      for (let i in context) {
        let targetObj = resArr.find((item: any) => item.keyword === i)!;

        targetObj &&
          (targetObj.wantToSetValue = context[i as keyof typeof context]);
      }
      handleSearch(context);
    }
    setStateSearchList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (applyId) {
      if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
        return;

      setRouterState({
        routerList: wantToSetInRouterList.current as any,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routerState.routerList]);

  useEffect(() => {
    return () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handInit = async () => {
    try {
      const res = await httpAPI_REC030({ applyId });

      if (res.resultCd === "I0000") {
        setBodyListData(
          GetBodyList(
            res.billingDataList,
            (i: any) => handleClickLinkId(i, context),
            true
          )
        );
        const statusList = funStatusBodyList(res.statusList);
        setStatusBodyList(statusList); // 「処理履歴」欄（入出力項目No.13～No.17）、メモ、照会画面への反映を表示する。

        if (isStatusAfterApproval(res.latestApplyStatus)) {
          // (ⅰ)1.(1).最新申請状態が"08"(通知待ち)または"11"(郵送待ち)または"13"(処理完了)の場合
          const bodyList = [
            [
              {
                children: (
                  <TkDownloadLink
                    dataname={TkGetCode(FormClassApply, "EXP0402034")}
                    base64filedata=""
                    linkDisabled
                  />
                ),
              },
              { children: res.symbolNo },
              { children: res.decisionDate },
            ],
          ];
          setBodyListData2(bodyList);
          handleInit(); // 非同期処理を開始する。
        }

        setCorpApplyKbn(res.corpApplyKbn); //  法人申請区分
        setStatus(res.latestApplyStatus); //1.(1).最新申請状態
        setTableListData(res.billingDataList);
        setNumData(res.billingDataList?.length);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 掛金の過納額の返戻について（通知文差込データ用）リンク 押下
  const downloadLink = async (downloadId: any) => {
    try {
      const res = await httpAPI_COM005({
        formList: [{ requestId: downloadId }],
      });
      if (res.resultCd === "I0000") {
        setBodyListData2((prev: any) => {
          res.formList &&
            (prev[0][0].children = (
              <TkDownloadLink
                downloadBase64
                base64filedata={res.formList[0].fileBase64 ?? ""}
                dataname={TkGetCode(FormClassApply, res.formList[0].formClass)}
              />
            ));

          return prev;
        });
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 非同期処理（帳票作成状況の確認）参照
  const handleInit = async () => {
    // 帳票作成状況取得API実行
    try {
      const res = await httpAPI_COM009({
        applyId: currentBusinessJob?.applyId ?? applyId, // 持ち回り情報
        FormList: [
          {
            formClass: "EXP0402034",
            formKbn: FormKbn["申請"],
          },
        ],
      });
      if (res.resultCd === "I0000") {
        res.FormList?.forEach((item) => {
          if (item.formOutputStatus === "3") {
            // 帳票出力リスト.帳票出力状態が"3"(出力完了)の場合
            downloadLink(item?.requestId); // 掛金の過納額の返戻について（通知文差込データ用） リンクを活性化する。	 // IDを設定する
          } else {
            // 上記以外の場合
            timerId.current = setTimeout(() => {
              handleInit();
            }, 10000); // 10秒間待機後 再度APIリクエストを送信
          }
        });
        setState({ ...state, errorMsgId: "" });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleClickLinkId = (item: any, search?: any) => {
    setBusinessStete({
      ...businessState,
      job_13: {
        demanderId: item,
        applyId,
      },
      paymentManagement: {
        searchForOverPayment: search,
      },
    });
    navigate("/SCRW160005");
  };

  const handleSearch = async (data: any) => {
    if (dateError) return;

    const reqData: IAPI_REC011_Request = {
      searchDepositDate: paymentDay,
      ...data,
    };
    try {
      const res = await httpAPI_REC011({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setTableListData(res.billingDataList);
        setNumData(res.billingDataList?.length);
        setBodyListData(
          GetBodyList(res.billingDataList, (i: any) =>
            handleClickLinkId(i, reqData)
          )
        );
        setBusinessStete({
          ...businessState,
          paymentManagement: {
            searchForOverPayment: reqData,
          },
        });
      } else {
        setTableListData([]);
        setNumData(0);
        setBodyListData([]);
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSelect = (arr: any) => {
    let data: any = [];
    arr.forEach((item: any) => {
      const filter = {
        invoiceId: tableListData[item].invoiceId,
        billingContractorNo: tableListData[item].billingContractorNo,
      };
      data.push(filter);
    });
    setSelectListData(data);
  };

  const handleChangeDate = (e: any) => {
    setPaymentDay(e.target.value);
  };

  const handleListLogin = () => {
    setIsOpen(true);
  };

  const handleOK = async () => {
    let dataList: any[] = [];
    selectListData.forEach((item: any) => {
      dataList.push({
        invoiceId: item.invoiceId,
        contractorNo: item.billingContractorNo,
      });
    });
    try {
      const res = await httpAPI_REC013({
        billingDataList: dataList,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
    setIsOpen(false);
  };

  const makeHttpObj = (num: string, formData?: any): IAPI_APP016_Request => {
    const data: IAPI_APP016_Request = {
      applyId,
      applyEvent: num,
      contractorNo: businessState?.common?.contractorNo,
      inquiryCode: memoCheck ? InquiryCode["契約者"] : undefined,
      screenId: "SCRW160009",
      reason: memoData,
    };
    if (formData?.symbolNumber !== undefined) {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      data.decisionDate = formData.settlementDate;
      data.transferDueDate = formData.scheduledPaymentDate;
    }

    return data;
  };

  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "契約者に差戻し"
        ? "5"
        : btnName === "受理"
        ? "2"
        : btnName === "承認"
        ? "3"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "上長承認"
        ? "6"
        : btnName === "郵送"
        ? "11"
        : btnName === "取下げ"
        ? "13"
        : "";

    if (num === "") {
      return;
    }

    if (num === "3") {
      setIsOpenWork(true);
      return;
    }

    let reqData: IAPI_APP016_Request = makeHttpObj(num);

    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        navigate("/SCRW110001");
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj("3", formData);
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRW160009" data-testid="SCRW160009PageForTest">
      {applyId && status && (
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType="JOB-68"
          applicationStatus={status}
          corporateApplicationClassification={corpApplyKbn}
        />
      )}

      {!applyId && (
        <Box>
          <TkSearchForm
            listData={stateSearchList}
            onSearch={handleSearch}
            ruleSchema={schema}
          />
          <Box className="datePicker">
            入金日：
            <TkDatePicker
              onChange={handleChangeDate}
              onGetErrorFlg={setDateError}
              maxDate={new Date()}
              wantToSetValue={context?.searchDepositDate}
            />
          </Box>
        </Box>
      )}

      <Box className="word">対象件数：{numData}件</Box>
      <TkDataTable
        headList={headList}
        bodyList={bodyListData}
        checkSection={true}
        onCheckSectionWidth={(indexArr: any) => handleSelect(indexArr)}
        showUnit={true}
        pagin
      />

      {applyId && (
        <TkMemo
          bodyList={statusBodyList}
          headList={headListHistory}
          showTable={true}
          onChange={onChange}
          disabledCheckBox={false}
        />
      )}

      {isStatusAfterApproval(status) && (
        <TkTableWithNoLine headList={listData2} bodyList={bodyListData2} />
      )}

      <Box className="btns">
        <TkBackButton
          className="btnMr"
          useBackParam
          navigateParam={{ applyId }}
        />
        {!applyId && (
          <TkButton
            className="btnMr"
            onClick={handleListLogin}
            disabled={!selectListData.length}
          >
            要処理一覧に登録
          </TkButton>
        )}
        {applyId && status && (
          // ワークフロー用表示ボタン判定
          <TkViewButtonJudgement
            flowType={"TYPE2"}
            businessType="JOB-68"
            Status={status}
            onClick={btnEvent}
          />
        )}
      </Box>
      <TkMessageDialog
        open={isOpen}
        onOky={handleOK}
        onCancel={() => setIsOpen(false)}
        title="要処理一覧に登録確認"
        contextText="　選択項目を要処理一覧へ登録します。問題ないでしょうか。"
        okText="はい"
        cancelText="いいえ"
      />

      <TkApprovalDateSymbolNumberRegistrationDialog
        data-testid="SCRW160009PageForDialog"
        open={isOpenWork}
        JobType="JOB-68"
        onSuccess={handleSave}
        onClose={() => setIsOpenWork(false)}
      />
    </Box>
  );
};

export default SCRW160009;
